import Button from "Components/Common/Button/Button";
import { Fragment } from "react";

interface Step {
  id: string;
  label: string;
}

interface StepsBarProps {
  steps: Step[];
  currentStep: number;
  onStepChange: (step: number) => void;
}

const StepsBar = ({ steps, currentStep, onStepChange }: StepsBarProps) => {
  return (
    <div className="craStepsBar">
      {steps.map((step, index) => {
        const stepNo = index + 1;
        const isDone = stepNo < currentStep;
        const isActive = stepNo === currentStep;

        return (
          <Fragment key={step.id}>
            <Button
              type="button"
              className={`craStep ${isActive ? "active" : ""} ${isDone ? "done" : ""}`}
              onClick={() => onStepChange(stepNo)}
            >
              <span className="craStep__num">{isDone ? "✓" : stepNo}</span>
              <span>{step.label}</span>
            </Button>
            {stepNo !== steps.length ? (
              <span className="craStep__arrow">{"›"}</span>
            ) : null}
          </Fragment>
        );
      })}
    </div>
  );
};

export default StepsBar;
